import { buildCdnUrl } from "@/shared/constants/publicUrlConstants";

export interface BrandBanner {
  src: string;
  width: number;
  height: number;
}

export interface BrandBannerConfig {
  mobile?: BrandBanner[];
  tablet?: BrandBanner[];
  desktop?: BrandBanner[];
}

export const BRAND_BANNERS: Record<string, BrandBannerConfig> = {
  topgear: {
    mobile: [
      {
        src: buildCdnUrl("/banners/TopGear/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/TopGear/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/TopGear/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/TopGear/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/TopGear/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/TopGear/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/TopGear/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/TopGear/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/TopGear/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  bassoholic: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Bassoholic/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Bassoholic/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Bassoholic/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Bassoholic/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Bassoholic/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Bassoholic/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Bassoholic/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Bassoholic/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Bassoholic/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  premium1: {
   mobile: [
      {
        src: buildCdnUrl("/banners/Premium1/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Premium1/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Premium1/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Premium1/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Premium1/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Premium1/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Premium1/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Premium1/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Premium1/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  trony: {
   mobile: [
      {
        src: buildCdnUrl("/banners/Trony/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Trony/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Trony/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Trony/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Trony/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Trony/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Trony/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Trony/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Trony/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  nippon: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Nippon/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Nippon/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Nippon/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Nippon/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Nippon/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Nippon/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Nippon/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Nippon/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Nippon/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  viofo: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Viofo/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Viofo/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Viofo/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Viofo/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Viofo/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Viofo/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Viofo/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Viofo/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Viofo/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  gotboost: {
    mobile: [
      {
        src: buildCdnUrl("/banners/GotBoost/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/GotBoost/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/GotBoost/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/GotBoost/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/GotBoost/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/GotBoost/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/GotBoost/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/GotBoost/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/GotBoost/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  crab: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Crab/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Crab/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Crab/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Crab/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Crab/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Crab/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Crab/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Crab/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Crab/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  kenwood: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Kenwood/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Kenwood/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Kenwood/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Kenwood/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Kenwood/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Kenwood/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Kenwood/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Kenwood/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Kenwood/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  
  neodrift: {
    mobile: [
      {
        src: buildCdnUrl("/banners/NeoDrift/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/NeoDrift/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/NeoDrift/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/NeoDrift/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/NeoDrift/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/NeoDrift/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/NeoDrift/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/NeoDrift/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/NeoDrift/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  culibody: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Culibody/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Culibody/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Culibody/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Culibody/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Culibody/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Culibody/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Culibody/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Culibody/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Culibody/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  monoblast: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Monoblast/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Monoblast/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Monoblast/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Monoblast/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Monoblast/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Monoblast/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Monoblast/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Monoblast/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Monoblast/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  xlxaudio: {
    mobile: [
      {
        src: buildCdnUrl("/banners/XlxAudio/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/XlxAudio/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/XlxAudio/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/XlxAudio/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/XlxAudio/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/XlxAudio/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/XlxAudio/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/XlxAudio/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/XlxAudio/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  homnix: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Homnix/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Homnix/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Homnix/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Homnix/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Homnix/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Homnix/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Homnix/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Homnix/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Homnix/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  acto: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Acto/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Acto/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Acto/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Acto/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Acto/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Acto/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Acto/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Acto/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Acto/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  megaaudio: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Megaaudio/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Megaaudio/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Megaaudio/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Megaaudio/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Megaaudio/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Megaaudio/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Megaaudio/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Megaaudio/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Megaaudio/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  amvee: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Amvee/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Amvee/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Amvee/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Amvee/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Amvee/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Amvee/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Amvee/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Amvee/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Amvee/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  dbase: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Dbase/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Dbase/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Dbase/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Dbase/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Dbase/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Dbase/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Dbase/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Dbase/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Dbase/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  axonify: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Axonify/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Axonify/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Axonify/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Axonify/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Axonify/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Axonify/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Axonify/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Axonify/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Axonify/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  airofy: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Airofy/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Airofy/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Airofy/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Airofy/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Airofy/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Airofy/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Airofy/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Airofy/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Airofy/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  starq: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Starq/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Starq/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Starq/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Starq/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Starq/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Starq/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Starq/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Starq/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Starq/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  bsoul: {
    mobile: [
      {
        src: buildCdnUrl("/banners/Besoul/MOB 1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Besoul/MOB 2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Besoul/MOB 3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/Besoul/TAB 1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Besoul/TAB 2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Besoul/TAB 3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/Besoul/DESK 1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/Besoul/DESK 2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/Besoul/DESK 3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  carizmo: {
    mobile: [
      {
        src: buildCdnUrl("/banners/carizmo/MOB+1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/carizmo/MOB+2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/carizmo/MOB+3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/carizmo/TAB+1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/carizmo/TAB+2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/carizmo/TAB+3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/carizmo/DESK+1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/carizmo/DESK+2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/carizmo/DESK+3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  portronics: {
    mobile: [
      {
        src: buildCdnUrl("/banners/portronics/MOB+1.png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/portronics/MOB+2.png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/portronics/MOB+3.png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/portronics/TAB+1.png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/portronics/TAB+2.png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/portronics/TAB+3.png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/portronics/DESK+1.png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/portronics/DESK+2.png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/portronics/DESK+3.png"),
        width: 3350,
        height: 590,
      },
    ],
  },
  stormpuls: {
    mobile: [
      {
        src: buildCdnUrl("/banners/MOB_1[1].png"),
        width: 1414,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/MOB_2[1].png"),
        width: 1414,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/MOB_3[1].png"),
        width: 980,
        height: 590,
      },
    ],
    tablet: [
      {
        src: buildCdnUrl("/banners/TAB_1[1].png"),
        width: 2270,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/TAB_2[1].png"),
        width: 2180,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/TAB_3[1].png"),
        width: 2060,
        height: 590,
      },
    ],
    desktop: [
      {
        src: buildCdnUrl("/banners/DESK_1[1].png"),
        width: 3350,
        height: 1780,
      },
      {
        src: buildCdnUrl("/banners/DESK_2[1].png"),
        width: 3350,
        height: 990,
      },
      {
        src: buildCdnUrl("/banners/DESK_3[1].png"),
        width: 3350,
        height: 590,
      },
    ],
  },
};
